import {Component, OnInit} from '@angular/core';
import {routePath} from 'sdv-common';
import {ApiService} from '../service/api.service';
import {redirect} from '../shared/constants';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss']
})
export class SignOutComponent implements OnInit {

  constructor(private apiService: ApiService) {
    if (this.apiService.isAuthorized()) {
      this.apiService.signOut();
      redirect(routePath.root)
    }
  }

  ngOnInit() {
  }
}
